module.exports = __webpack_public_path__ + "img/ic_footer_social_twitter.5e5138f5.svg";